export const Cookie = {
	/**
	 * Cookie lekérdezése
	 *
	 * @param  name	Név
	 * @param  def		Alap érték (def.: '')
	 * @return 			Letárolt érték ha van, ha nincs akkor a default
	 */
	get: (name: string, def = ""): string => {
		const extendedName = `${name}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		const result = decodedCookie
			.split(";")
			.map((item: string) => item.replace(/^\s+/, ""))
			.find((item: string) => item.startsWith(extendedName));

		if (result) {
			return result.replace(extendedName, "");
		}

		return def;
	},

	/**
	 * Cookie mentése
	 *
	 * @param  name		Név
	 * @param  value	Érték
	 * @param  exmin	Lejárat ideje percben (def.: 24 perc)
	 * @param  domain	Érvényes domain (def.: .bankmonitor.hu)
	 */
	set: (name: string, value: string, exmin = 24): void => {
		let expires = "Thu, 01 Jan 1970 00:00:00 GMT";
		const domain = `${window.location.href.replace("https://", "").split("/")[0]}`;

		// Törlés
		if (value !== undefined && value !== "") {
			const d = new Date();
			d.setTime(d.getTime() + exmin * 60 * 1000);
			expires = d.toUTCString();
		}

		document.cookie = `${encodeURI(name)}=${encodeURI(
			value,
		)};expires=${expires};domain=${domain};path=/;Secure;SameSite=None`;
	},
};
